(() => {
    const root = document.currentScript.closest('[data-rcm]');
    if (!root || root.__rcm_inited) return;
    root.__rcm_inited = true;

    const viewport = root.querySelector('[data-rcm-viewport]');
    const track = root.querySelector('[data-rcm-track]');
    const segment = root.querySelector('[data-rcm-segment]');
    if (!viewport || !track || !segment) return;

    const prefersReduced = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
    if (prefersReduced) return;

    const SPEED_FALLBACK = 80; // px/s
    const getSpeed = () => {
        const v = parseFloat(getComputedStyle(root).getPropertyValue('--rcm-speed'));
        return Number.isFinite(v) && v > 0 ? v : SPEED_FALLBACK;
    };

    const cleanupClones = () => {
        track.querySelectorAll('[data-rcm-clone]').forEach(n => n.remove());
        track.classList.remove('is-ready');
        track.style.removeProperty('--rcm-shift');
        track.style.removeProperty('--rcm-duration');
    };

    const waitImages = () => {
        const imgs = Array.from(segment.querySelectorAll('img'));
        if (!imgs.length) return Promise.resolve();
        return new Promise(resolve => {
            let pending = 0;
            const done = () => {
                pending--;
                if (pending <= 0) resolve();
            };
            imgs.forEach(img => {
                if (img.complete) return;
                pending++;
                img.addEventListener('load', done, {once: true});
                img.addEventListener('error', done, {once: true});
            });
            if (pending === 0) resolve();
        });
    };

    const measureSegmentWidth = () => {
        // scrollWidth معمولاً از boundingClientRect پایدارتره برای ساب‌پیکسل/فونت
        return Math.ceil(segment.scrollWidth || segment.getBoundingClientRect().width || 0);
    };

    const build = async () => {
        cleanupClones();

        await waitImages();
        if (document.fonts?.ready) {
            try {
                await document.fonts.ready;
            } catch (e) {
            }
        }

        // دو فریم صبر کن تا layout کامل settle بشه
        await new Promise(r => requestAnimationFrame(() => requestAnimationFrame(r)));

        const segW = measureSegmentWidth();
        const vpW = Math.ceil(viewport.getBoundingClientRect().width);

        if (!segW || segW < 2 || !vpW) return;

        // باید حداقل به اندازه (viewport + یک segment) محتوا داشته باشیم
        const neededCount = Math.min(12, Math.ceil((vpW + segW) / segW) + 1);
        for (let i = 1; i < neededCount; i++) {
            const clone = segment.cloneNode(true);
            clone.setAttribute('data-rcm-clone', 'true');
            clone.setAttribute('aria-hidden', 'true');
            track.appendChild(clone);
        }

        const speed = getSpeed(); // px/s
        const duration = Math.max(6, Math.round((segW / speed) * 100) / 100);

        track.style.setProperty('--rcm-shift', segW + 'px');
        track.style.setProperty('--rcm-duration', duration + 's');
        track.classList.add('is-ready');
    };

    let raf = null;
    const schedule = () => {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(build);
    };

    const ro = new ResizeObserver(schedule);
    ro.observe(viewport);
    ro.observe(segment);

    schedule();
})();